var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gongyi-detail"},[_c('div',{staticClass:"tencent-icon-tips",on:{"click":_vm.showTencentTips}},[_c('div',{staticClass:"tencent-icon-flower-man"})])])}
var staticRenderFns = []

export { render, staticRenderFns }